/**
 * NotFoundPage - A 404 error page displayed when the user navigates to
 * a route that does not match any defined route in the application.
 *
 * Shows a large "404" heading, a brief explanation, and a link back to
 * the dashboard so the user can recover gracefully.
 *
 * This page is NOT wrapped in <ProtectedRoute>, so it is accessible
 * to both authenticated and unauthenticated users.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
	return (
		<div className="not-found-page min-h-screen min-h-[100dvh] flex items-center justify-center bg-[#eae5e5] px-16px" data-ref="page-not-found-page">
			<div className="text-center">
				{/* Large muted 404 heading */}
				<h1 className="text-6xl font-bold font-heading text-brand-text-subtle">404</h1>
				<p className="mt-16px text-20px font-sans text-brand-text">Page not found</p>
				<p className="mt-8px font-sans text-brand-text-subtle">The page you are looking for does not exist.</p>
				{/* Navigation link back to the dashboard (root route) */}
				<Link to="/" className="mt-24px inline-block px-24px py-8px bg-brand-primary text-white rounded-md text-14px font-medium font-sans hover:bg-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary">Go to Dashboard</Link>
			</div>
		</div>
	);
};

export default NotFoundPage;
